<template>
  <!-- star -->
  <div class="contact_wrap">
    <navigation></navigation>
    <div class="banner_warp">
      <img class="banner_warp_img" src="../assets/img/contact/contact_banner.png"/>
    </div>

    <!-- contact -->
    <div class="contact">
      <div class="contact-top"></div>
      <h1>慧昀心境</h1>
      <div class="contact-line"></div>
      <div class="contact-content">
        <div class="contact-items">
          <div class="contact-item1">
            <div class="contact-item1-cont">
              <img src="../assets/img/contact/contact_information.png" alt=""/>
              <div class="contact-item1-text">
                <p>联系方式</p>
                <span>contact information</span>
                <h2>咨询电话：13850002860</h2>
              </div>
            </div>
          </div>
          <div class="contact-item2">
            <div class="contact-item2-cont">
              <img src="../assets/img/contact/mailbox.png" alt=""/>
              <div class="contact-item2-text">
                <p>邮箱</p>
                <span>mailbox</span>
                <h2>sales@huiyunpico.com</h2>
              </div>
            </div>
          </div>
          <div class="contact-item3">
            <div class="contact-item3-cont">
              <img src="../assets/img/contact/address.png" alt=""/>
              <div class="contact-item3-text">
                <p>地址</p>
                <span>address</span>
                <h2>厦门市湖里区高新技术园安岭二路35号奥佳华佰翊大楼916</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--map-->
    <div class="map_warp">
      <div class="map_warp_content">
        <img class="map_logo" src="../assets/img/contact/hy_logo.png">
        <p>厦门慧云柏科智能科技有限公司是奥佳华集团控股子公司，是一家专业从事心理素质教育软硬件产品研制生产、方案设计、培训交流和学术研究于一体的应用心理学领域的专业机构，可提供心理服务中心一站式整体化解决方案。</p>
      </div>
    </div>
    <div id="map" class="map" >
      <baidu-map @ready="handler"></baidu-map>
    </div>

    <footer2></footer2>
    <!-- end -->
  </div>
</template>

<script>
import navigation from "../components/nav2.vue";
import footer2 from "../components/footer.vue";

export default {
  name: "contact",
  components: {
    navigation,
    footer2
  },
  data() {
    return {

    }
  },
  methods: {
    handler() {
      let map = new BMap.Map("map");
      let point = new BMap.Point(118.165595, 24.532266);
      map.centerAndZoom(point, 18);
      map.addControl(new BMap.NavigationControl());//添加控件
      map.addControl(new BMap.ScaleControl());
      map.addControl(new BMap.OverviewMapControl());
      map.addControl(new BMap.MapTypeControl());
      map.enableScrollWheelZoom(true);//开启滚动
      let marker = new BMap.Marker(point);        // 创建标注
      map.addOverlay(marker);
    },
  }
};
</script>
<style scoped>
/*=========================Reset_start==========================*/
body,
h1,
h2,
h3,
h4,
h5,
h6,
div,
p,
dl,
dt,
dd,
ol,
ul,
li,
form,
table,
th,
td,
a,
img,
span,
strong,
var,
em,
input,
textarea,
select,
option {
  margin: 0;
  padding: 0;
}

/*去内外边距*/
html,
body {
  font-family: "微软雅黑", "宋体", Arail, Tabhoma;
  text-align: left;
}

/*字体 文本居左*/
ul {
  list-style: none;
}

/*去ul li 小点*/
img {
  border: 0 none;
}

/*img IE6 兼容问题*/
input,
select,
textarea {
  outline: 0;
}

/*去除点击蓝框*/
textarea {
  resize: none;
  overflow: auto;
}

/*锁定多行文本框大小 与文字超出出现滚动条*/
table {
  border-collapse: collapse;
  border-spacing: 0;
}

/*表格边框合并 边框间距0*/
th,
strong,
var,
em {
  font-weight: normal;
  font-style: normal;
}

/*特殊文字粗细 样式显示正常*/
a {
  text-decoration: none;
}

/*a标签去下划线*/
.clearfix:after {
  clear: both;
  content: "";
  display: block;
  height: 0;
}

/*清浮动*/
a {
  color: #000000;
}

/*==========================Reset_End===========================*/
.contact_wrap {
  width: 100vw;
  margin: 0 auto;
  height: 1000px;
}

.banner_warp {
  position: relative;
  width: 1204px;
  height: 246px;
  margin: 0 auto;
}

.banner_warp_img {
  width: 1204px;
  z-index: -999;
  position: absolute;
  height: 246px;
}

.contact {
  width: 100%;
  height: 450px;
  background-size: contain;
}

.contact h1 {
  color: #000000;
  font-size: 24px;
  line-height: 90px;
  text-align: center;
  font-weight: 600;
  font-family: PingFang SC, PingFang SC;
}

.contact-top {
  width: 100%;
  padding-top: 60px;
}

.contact-line {
  margin: auto;
  width: 252px;
  height: 0px;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 1px solid #B1B1B1;
}

.contact-content {
  /*display: flex;*/
  margin-top: 50px;
}

.contact-items {
  width: 1203px;
  height: 151px;
  margin: 0 auto;
  display: flex;
}

.contact-item1 {
  width: 401px;
  height: 151px;
}

.contact-item1-cont {
  display: flex;
  margin-left: 40px;
  margin-bottom: 40px;
  width: 401px;
  height: 151px;
}

.contact-item1-cont img {
  /*margin-top: 140px;*/
  /*margin-left: 68px;*/
  width: 64px;
  height: 64px;
}

.contact-item1-text {
  width: 300px;
  height: 151px;
}

.contact-item1-text p {
  margin-top: 17px;
  margin-left: 38px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 19px;
}

.contact-item1-text span {
  margin-top: 5px;
  margin-left: 38px;
  display: inline-block;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #B9B9B9;
  line-height: 16px;
}

.contact-item1-text h2 {
  margin-left: 38px;
  margin-top: 15px;
  width: 186px;
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #424242;
  line-height: 19px;
}

.contact-item2 {
  width: 401px;
  height: 151px;
  /*background-color: #F9F9F9;*/
}

.contact-item2-cont {
  display: flex;
  margin-left: 40px;
  margin-bottom: 40px;
}

.contact-item2-cont img {
  /*margin-top: 140px;*/
  /*margin-left: 68px;*/
  width: 64px;
  height: 64px;
}

.contact-item2-text {
  width: 300px;
  height: 151px;
}

.contact-item2-text p {
  margin-top: 17px;
  margin-left: 38px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 19px;
}

.contact-item2-text span {
  margin-top: 5px;
  margin-left: 38px;
  display: inline-block;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #B9B9B9;
  line-height: 16px;
}

.contact-item2-text h2 {
  margin-left: 38px;
  margin-top: 15px;
  width: 186px;
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #424242;
  line-height: 19px;
}

.contact-item3 {
  width: 401px;
  height: 151px;
  /*background-color: #F9F9F9;*/
}

.contact-item3-cont {
  display: flex;
  margin-left: 40px;
  margin-bottom: 40px;
}

.contact-item3-cont img {
  /*margin-top: 140px;*/
  /*margin-left: 68px;*/
  width: 64px;
  height: 64px;
}

.contact-item3-text {
  width: 300px;
  height: 151px;
}

.contact-item3-text p {
  margin-top: 17px;
  margin-left: 38px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 19px;
}

.contact-item3-text span {
  margin-top: 5px;
  margin-left: 38px;
  display: inline-block;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #B9B9B9;
  line-height: 16px;
}

.contact-item3-text h2 {
  margin-left: 38px;
  margin-top: 15px;
  width: 250px;
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #424242;
  line-height: 19px;
}

.map_warp {
  width: 1920px;
  height: 208px;
  background-image: url("../assets/img/contact/map_banner.png");
  background-size: contain;
}

.map_warp_content {
  /*position: absolute;*/
  /*left: 845px;*/
  /*top: 1110px;*/
  width: 1920px;
  height: 208px;
}

.map_warp_content p {
  margin-left: 514px;
  width: 911px;
  height: 40px;
  padding-top: 24px;
  text-align: center;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 20px;
}

.map_logo {
  margin-top: 55px;
  margin-left: 903px;
  width: 133px;
  height: 24px;
}

.map {
  width: 1920px;
  height: 818px;
}
</style>
